import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { translate } from '../../utils/useful'
import { siteConfig, brandColors } from '../../variables/config'

class LoginFirstStep extends React.Component {
  state = {
    key: '',
    selectedCountry: {},
    data: { username: 'iranteam' },
    isLoading: false,
    // captchaCode: '',
    // captchaInput: '',
    formHeaders: [
      { key: 'username', type: 'TextInput', information: { label: '{{lang}}username', icon: '/images/man.svg', placeholder: '{{lang}}username', required: true } },
      { key: 'password', type: 'PasswordInput', information: { label: '{{lang}}password', icon: '/images/key.svg', placeholder: '{{lang}}password', required: true } }
    ]
  }

  componentDidMount() {
    document.addEventListener("keydown", this._handleKeyDown);
    // this.generateCaptcha();
  }

  // generateCaptcha = () => {
  //   const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   let result = '';
  //   for (let i = 0; i < 6; i++) {
  //     result += chars.charAt(Math.floor(Math.random() * chars.length));
  //   }
  //   this.setState({ captchaCode: result, captchaInput: '' });
  // }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this._handleKeyDown);
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.postUserIndicator()
    }
  }

  postUserIndicator = () => {
    let data = this.form.getForm()
    if (data) {
      // if (!this.state.captchaInput || this.state.captchaInput !== this.state.captchaCode) {
      //   this.setState({ errors: { captcha: '{{lang}}captchaInvalid' } });
      //   return;
      // }
      this.setState({ isLoading: true, errors: {} })
      this.props.setData(data, () => {
        this.props.postUserIndicator((result, err) => {
          if (err) {
            this.setState({ isLoading: false, errors: err });
            // this.generateCaptcha();
          } else {
            this.setState({ isLoading: false })
          }
        })
      })
    }
  }

  render() {
    const { errors } = this.state
    const showErrorBanner = errors && typeof errors === 'string'

    return (
      <div className="flexcc flex-column w-100">
        <img className="mb-2" src="/images/Logo1.png" width="72px" alt="" />
        <h2 className="login-brand-title text-center">{siteConfig.siteName}</h2>
        <p className="login-brand-subtitle text-center">{translate('Admin Panel')}</p>

        <div className="w-100">
          {showErrorBanner && (
            <div className="login-error-banner">{translate(errors)}</div>
          )}

          <FormViewer
            ref={el => this.form = el}
            headers={this.state.formHeaders}
            initData={this.props.initData}
            loginError={this.props.loginError}
            errors={this.state.errors}
            inputClass="login-input"
          />

          {/* Captcha temporarily disabled
          <div className="mt-3 mb-3">
            ...
          </div>
          */}

          <div className="text-center mt-4">
            <LoaderButton
              onClick={this.postUserIndicator}
              isLoading={this.state.isLoading}
              text={translate('login')}
              type="Oval"
              className="mb-2"
              buttonStyle={{}}
              buttomClassName="login-submit-btn"
              width={40}
              height={40}
              color={brandColors.primaryDark}
            />
            <p className="login-footer-note">{translate('cookie-warning')}</p>
          </div>
        </div>
      </div>
    )
  }
}

export default LoginFirstStep
